// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { AddressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import InjectableCss, { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import {
    checkoutReviewLabel,
    checkoutReviewLabelValueWrapper,
    checkoutReviewValue,
} from "@pacific/App/SharedStyle/CheckoutPageStyles";
import { avoidBreakInsidePrintElement, color, xScreen } from "@pacific/XDL/Utilities";
import { css } from "styled-components";

/**
 * We don't use TypographyPresentationProps, because we need to inject style by css
 */
interface OrderInformationStyles {
    label?: StyledProp<any>;
    value?: StyledProp<any>;
    headingAndTextStyles?: SmallHeadingAndTextStyles;
    address?: { title?: TypographyPresentationProps } & AddressInfoDisplayStyles;
    note?: { wrapper?: InjectableCss; title?: TypographyProps; text?: TypographyProps };
    orderSummary?: any;
}

const xOrderInformationStyles: OrderInformationStyles = {
    label: css`
        font-weight: bold;
        font-size: 13px;
        margin-right: 10px;
        line-height: 18px;
        white-space: nowrap;
        text-transform: capitalize;
    `,
    value: css`
        font-size: 12px;
        line-height: 18px;
        white-space: nowrap;
        &:empty:after {
            content: "#";
        }
    `,
};

xOrderInformationStyles.headingAndTextStyles = {
    wrapper: {
        ...checkoutReviewLabelValueWrapper,
    },
    heading: {
        ...checkoutReviewLabel,
    },
    text: {
        ...checkoutReviewValue,
    },
};

xOrderInformationStyles.address = {
    title: {
        variant: "h5",
        css: css`
            border-bottom: 1px solid ${color("common.border")};
            padding-bottom: 12px;
            margin-bottom: 16px;

            @media print {
                margin-bottom: 3px;
                padding-bottom: 3px;
                margin-right: 16px;
            }
        `,
    },
};

xOrderInformationStyles.note = {
    title: {
        variant: "h5",
        css: css`
            border-bottom: 1px solid ${color("common.border")};
            padding-bottom: 12px;
            margin-bottom: 16px;
        `,
    },
};

xOrderInformationStyles.orderSummary = {
    css: css`
        ${avoidBreakInsidePrintElement}
        ${xScreen("lte", "md")} {
            margin-bottom: 10px;
        }
    `,
};

export default xOrderInformationStyles;
